import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';

import DietaryTagActions from '../flux/actions/DietaryTagActions';
import DietaryTagStore from '../flux/stores/DietaryTagStore';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import Layout from '../components/Layout';
import LockIcon from '@mui/icons-material/Lock';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Switch from '@mui/material/Switch';
import { logIn } from '../utility/index.js';
import {useAppState} from '../../index.js';

const MenuSetting = (props) => {
  const { Name, Type, filters, switches, makeSelection, } = props;
  let selection = filters[0] ? 'Must Not Have' : filters[1] ? 'Must Have' : 'Can Have';
  let verb = Type === "Allergen" ? " contain " : " are ";
  let descriptionText = [
    "Show items regardless of whether they" + verb + Name + ".",
    "Hide items that" + verb + Name + ".",
    "Show items only if they" + verb + Name + ".",

  ]
  let descriptionSelection = filters[0] ? descriptionText[1] : filters[1] ? descriptionText[2] : descriptionText[0];
  let switchText = [
    "Display the '" + Name + "' icon on the menu.",
    "Highlight items that" + verb + Name + "."
  ]
  let switchHighlightText = switches[1] ? switchText[1] : '';
  let escapedLabelName = Name.replace(/ /g, "-").toLowerCase();
  return (
    <FormGroup row className="filter__form" role="group" aria-labelledby={`${escapedLabelName}-group-label`}>
      <div id={`${escapedLabelName}-group-label`} className="sr-only">{Name} dietary trait settings</div>
      <FormControl className="filter__form--dropdown">
        <InputLabel htmlFor={escapedLabelName + "-menu_setting"} id={`${escapedLabelName}-label`}>{Name} Menu Setting</InputLabel>
        <Select
          value={selection}
          className={"filter__form--select"}
          onChange={(event) => makeSelection(Name, event.target.value)}
          label={`${Name} Menu Setting`}
          labelId={`${escapedLabelName}-label`}
          id={`${escapedLabelName}-menu_setting`}
          inputProps={{ name: escapedLabelName + "-menu_setting", 'aria-describedby': `${escapedLabelName}-description` }}
        >
          <MenuItem value="Can Have">
            Can Have
          </MenuItem>
          <MenuItem style={Type !== "Allergen" ? { display: "none" } : {}} disabled={Type !== "Allergen" ? true : false} value="Must Not Have">
            Must Not Have
          </MenuItem> :
          <MenuItem style={Type === "Allergen" ? { display: "none" } : {}} disabled={Type === "Allergen" ? true : false} value="Must Have">
            Must Have
          </MenuItem>
        </Select>
        <FormHelperText id={`${Name}-description`} style={{ color: "#000000" }}>{descriptionSelection}</FormHelperText>
      </FormControl>
      {!filters[0] ?
        <FormGroup column="true" className="filter__form--switches">
          <FormControlLabel control={
            <Switch 
              checked={switches[1]} 
              onChange={(event) => makeSelection(Name, event.target.checked, "Highlight")} 
              value={"Highlight"} 
              color="primary" 
              inputProps={{
                'aria-describedby': `${Name}-highlight-description`,
                'aria-label': `Highlight ${Name} items on menu`
              }}
            />
          }
            label={`Highlight ${Name}`} />
          <FormHelperText id={`${Name}-highlight-description`} style={{ color: "#000000" }}>{switchHighlightText}</FormHelperText>
        </FormGroup>
        :
        ''
      }
    </FormGroup>
  )
}

const SettingsContent = (props) => {
  const { AppContext, currentUser } = props;
  const { styleprops, dietaryTags } = useContext(AppContext);
  const [filters, setFilters] = useState();
  // const [dietaryTags, setDietaryTags] = useState();

  const _userPreferanceChange = useCallback(() => {
    if (currentUser !== "Guest" && Object.keys(currentUser).length !== 0) {
      let filterFetch = DietaryTagStore.getUserDietaryTags()
      setFilters(filterFetch);
    }
  }, [currentUser]);

  useEffect(() => {
    let _userPreferanceChangeToken = DietaryTagStore.addListener(_userPreferanceChange);
    _userPreferanceChange();
    return () => {
      _userPreferanceChangeToken.remove();
    };
  }, [_userPreferanceChange]);

  function makeSelection(trait, option, action) {
    if (!action) {
      //remove all refrences to the name that is being filtered
      let mustHave = filters.ShowOnly.indexOf(trait);
      if (mustHave > -1) {
        filters.ShowOnly.splice(mustHave, 1);
      }
      let mustNotHave = filters.Hidden.indexOf(trait);
      if (mustNotHave > -1) {
        filters.Hidden.splice(mustNotHave, 1);
      }
      //next push the name into the object
      if (option !== "Can Have (Default)") {
        if (option === "Must Have") {
          filters["ShowOnly"].push(trait);
        }
        else if (option === "Must Not Have") {
          filters["Hidden"].push(trait);
        }
      }
    }
    else if (action === "Icon") {
      let showIcon = filters.ShowIcon.indexOf(trait);
      if (showIcon > -1) {
        filters.ShowIcon.splice(showIcon, 1);
      }
      if (option === true) {
        filters["ShowIcon"].push(trait);
      }
    }
    else if (action === "Highlight") {
      let highlight = filters.Flagged.indexOf(trait);
      if (highlight > -1) {
        filters.Flagged.splice(highlight, 1);
      }
      if (option === true) {
        filters["Flagged"].push(trait);
      }
    }
    DietaryTagActions.updateUserDietaryTags(filters);
  }

  function renderFilters() {
    let allerList = null;
    let prefList = null;

    if (dietaryTags && dietaryTags.length > 0 && filters) {
      allerList = dietaryTags.map(function (a, i) {
        let showIcon = filters.ShowIcon.includes(a.Name);
        let highlight = filters.Flagged.includes(a.Name);
        let mustNotHave = filters.Hidden.includes(a.Name);
        let mustHave = filters.ShowOnly.includes(a.Name);
        
        if (a.Type === "Allergen") {

          return (
            <div className="allergen__filter" key={a.Name} role="group" aria-labelledby={`allergen-${a.Name}-name`}>
              <div className="allergen__filter--icon">
                <i className="allergen-icon" style={{ backgroundImage: 'url(' + a.SvgUrl + ')' }} aria-hidden="true" />
                <span className="allergen-name" id={`allergen-${a.Name}-name`}>{a.Name}</span>
              </div>
              <MenuSetting {...a} filters={[mustNotHave, mustHave]} switches={[showIcon, highlight]} makeSelection={makeSelection} />
            </div>
          )
        }
        return null; // Add explicit return for items that don't match
      }).filter(Boolean);

      prefList = dietaryTags.map(function (a, i) {
        let showIcon = filters.ShowIcon.includes(a.Name);
        let mustNotHave = filters.Hidden.includes(a.Name);
        let mustHave = filters.ShowOnly.includes(a.Name);
        let highlight = filters.Flagged.includes(a.Name);

        if (a.Type === "Preference") {
          return (

            <div className="allergen__filter" key={a.Name} role="group" aria-labelledby={`preference-${a.Name}-name`}>
              <div className="allergen__filter--icon">
                <i className="allergen-icon" style={{ backgroundImage: 'url(' + a.SvgUrl + ')' }} aria-hidden="true" />
                <span className="allergen-name" id={`preference-${a.Name}-name`}>{a.Name}</span>
              </div>
              <MenuSetting {...a} filters={[mustNotHave, mustHave]} switches={[showIcon, highlight]} makeSelection={makeSelection} />
            </div>
          )
        }
        return null; // Add explicit return for items that don't match
      }).filter(Boolean);
    }
    return (
      <div>
        <div>
          <h2 className='c-settings-title'>Apply Dietary Restrictions to Residential Dining Menus</h2>
          <p>
            Personalize <strong>Dietary Traits</strong> to customize your menus to your dietary restrictions and preferences. To display or hide food items and dishes with certain traits, click on the <strong>menu setting dropdown</strong> for a trait and select your preferences:
          </p>
          <ul role="list" aria-label="Dietary trait preferences">
            <li aria-setsize="3" data-aria-level="1" data-aria-posinset="1" data-font="Symbol" data-leveltext="" data-listid="2"> <strong>"Can have"</strong> is a default preference that means the trait will be shown in your menu regardless of whether this trait is present.</li>
            <li aria-setsize="3" data-aria-level="1" data-aria-posinset="2" data-font="Symbol" data-leveltext="" data-listid="2"> <strong>"Must not have"</strong> hides items with this trait.&nbsp;</li>
            <li aria-setsize="3" data-aria-level="1" data-aria-posinset="3" data-font="Symbol" data-leveltext="" data-listid="2"> <strong>"Must have"</strong> will only show items if they have this trait.&nbsp; &nbsp;</li>
          </ul>
          <p>
            Your dietary preferences will be applied when you view any residential dining menu. Note: dietary preferences do not apply to <strong>Retail Dining</strong> or <strong>Mobile Ordering menus</strong>.
          </p>
          <p>
            Turning on <strong>Highlight</strong> for a trait, will change the background color of items that contain that train on the daily menu.
          </p>
        </div>

        <div className="filters-group">
          <div className="filters-preferences">
            <h3 className='c-settings-title'>Preferences</h3>
            <div>
              {prefList}
            </div>
          </div>
          <div className="filters-allergens">
            <h3 className='c-settings-title'>Allergens</h3>
            <div>
              {allerList}
            </div>
          </div>
        </div>
      </div>
    )
  }

  function renderBlank() {
    let status = 'error';
    if (currentUser !== "Guest") {
      //theoretically, the user should never see this message. If they do it means that there was an issue getting their menu settings.....
      return (
        <div className="login_message" >
          <div className={"message " + status}><div className="icon"><ErrorOutlineIcon /></div><div className="text">This is embarrassing {currentUser.FirstName}, we've encountered an error. Your menu settings were just here a moment ago... Try refreshing your page to see if they come back.</div></div>
        </div>
      )
    }
    else {
      return (
        <div className="login_message" >
          <div className={"message " + status} onClick={() => logIn()}><div className="icon"><ErrorOutlineIcon /></div><div className="text">Sorry, you need to log in to use this feature.</div></div>
          <span className="userpanel-account-link null-login-link" onClick={() => logIn()}><LockIcon /><span>Login</span></span>
        </div>
      )
    }

  }

  return (
    <main className={"mdl-layout__content"} style={{ ...styleprops, paddingTop: 68 }}>
      <div className="mdl-layout__content-page" id="main">
        <div className="filter-options">
          {currentUser !== "Guest" && filters ? <div className="filterPaper">
            {renderFilters()}
          </div> : renderBlank()}
        </div>
      </div>
    </main>
  )
}

const MenuSettings = (props) => {
  const {locations, currentUser, GET_USER} = useAppState();
  const {AppContext} = props;
  return (
    <>
      <Helmet>
        <title>Menu Settings - Purdue Dining Menus</title>
        <meta name="description" content="Customize your dining preferences and dietary restrictions for Purdue University dining menus. Set allergen filters and preferences." />
        <meta name="keywords" content="dietary restrictions, allergen filters, menu preferences, food allergies, dining customization" />
        <meta property="og:title" content="Menu Settings - Purdue Dining" />
        <meta property="og:description" content="Customize your dining preferences and dietary restrictions for better menu personalization." />
      </Helmet>
      <Layout AppContext={AppContext} locations={locations} currentUser={currentUser} GET_USER={GET_USER} pageName="Menu Settings">
        <SettingsContent AppContext={AppContext} locations={locations} currentUser={currentUser} GET_USER={GET_USER} />
      </Layout>
    </>
  );
}

export default MenuSettings;